import { render } from "./PorfileDash.vue?vue&type=template&id=256fc3d5"
import script from "./PorfileDash.vue?vue&type=script&lang=js"
export * from "./PorfileDash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__